import BaseService from "@/app/core/base/BaseService";
import { toast } from "react-toastify";
import { HandleErrors } from "../../util/helpers/ErrorHelper";

export const DeliveryController = {
  BaseModel: {
    userId: "string",
    originId: "string",
    origin: {
      name: "string",
      street: "string",
      neighborhood: "string",
      city: "string",
      state: "string",
      country: "st",
      zipCode: "string",
      number: "string",
      complement: "string",
      document: "string",
      email: "string",
      phone: "string",
      phoneExtension: "string",
      personType: 0,
      lat: 0,
      lng: 0,
      userId: "string"
    },
    destinationId: "string",
    destination: {
      name: "string",
      street: "string",
      neighborhood: "string",
      city: "string",
      state: "string",
      country: "st",
      zipCode: "string",
      number: "string",
      complement: "string",
      document: "string",
      email: "string",
      phone: "string",
      phoneExtension: "string",
      personType: 0,
      lat: 0,
      lng: 0,
      userId: "string"
    },
    quotationId: "string",
    carrierCode: 0,
    description: "string",
    term: 0,
    boxes: [
      {
        deliveryId: "string",
        name: "string",
        height: 0,
        width: 0,
        weight: 0,
        depth: 0,
        price: 0,
        items: [
          {
            boxId: "string",
            sku: "string",
            name: "string",
            description: "string",
            countryCode: "string",
            hscode: "string",
            weight: 0,
            quantity: 0,
            unitValue: 0
          }
        ]
      }
    ]
  },

  BaseResponse: {
    id: "string",
    createdAt: "2023-08-11T16:09:57.707Z",
    updatedAt: "2023-08-11T16:09:57.707Z",
    userId: "string",
    user: {
      id: "string",
      createdAt: "2023-08-11T16:09:57.707Z",
      updatedAt: "2023-08-11T16:09:57.707Z",
      firstName: "string",
      lastName: "string",
      email: "string",
      emailConfirmed: true,
      phoneNumber: "string",
      phoneNumberConfirmed: true,
      twoFactorEnabled: true,
      document: "string",
      documentType: 0,
      type: 0,
      status: 0,
      role: 0,
      fullName: "string",
      initials: "string"
    },
    originId: "string",
    origin: {
      id: "string",
      createdAt: "2023-08-11T16:09:57.707Z",
      updatedAt: "2023-08-11T16:09:57.707Z",
      userId: "string",
      name: "string",
      street: "string",
      neighborhood: "string",
      city: "string",
      state: "string",
      country: "string",
      zipCode: "string",
      number: "string",
      complement: "string",
      document: "string",
      email: "string",
      phone: "string",
      phoneExtension: "string",
      personType: 0,
      lat: 0,
      lng: 0
    },
    destinationId: "string",
    destination: {
      id: "string",
      createdAt: "2023-08-11T16:09:57.707Z",
      updatedAt: "2023-08-11T16:09:57.707Z",
      userId: "string",
      name: "string",
      street: "string",
      neighborhood: "string",
      city: "string",
      state: "string",
      country: "string",
      zipCode: "string",
      number: "string",
      complement: "string",
      document: "string",
      email: "string",
      phone: "string",
      phoneExtension: "string",
      personType: 0,
      lat: 0,
      lng: 0
    },
    operationCost: 0,
    totalPrice: 0,
    paymentId: "string",
    paymentCode: "string",
    paymentStatus: "string",
    processCode: "string",
    quotationId: "string",
    carrierCode: 0,
    description: "string",
    term: 0,
    status: 0,
    statusDescription: "string",
    boxes: [
      {
        id: "string",
        createdAt: "2023-08-11T16:09:57.708Z",
        updatedAt: "2023-08-11T16:09:57.708Z",
        deliveryId: "string",
        name: "string",
        height: 0,
        width: 0,
        weight: 0,
        depth: 0,
        price: 0,
        items: [
          {
            id: "string",
            createdAt: "2023-08-11T16:09:57.708Z",
            updatedAt: "2023-08-11T16:09:57.708Z",
            boxId: "string",
            sku: "string",
            name: "string",
            description: "string",
            countryCode: "string",
            hscode: "string",
            weight: 0,
            quantity: 0,
            unitValue: 0
          }
        ]
      }
    ],
    files: [
      {
        id: "string",
        createdAt: "2023-08-11T16:09:57.708Z",
        updatedAt: "2023-08-11T16:09:57.708Z",
        deliveryId: "string",
        name: "string",
        url: "string",
        reference: "string",
        contentType: "string"
      }
    ]
  },

  Insert: async function (data, response, error) {
    await BaseService(
      {
        method: "POST",
        url: "delivery/",
        data: data,
      },
      (res) => response(res),
      (err) => error !== undefined ? error(err) : toast.error(HandleErrors(err))
    );
  },

  Update: async function (data, response, error) {
    await BaseService(
      {
        method: "PUT",
        url: `delivery/${data.id}`,
        data: data,
      },
      (res) => response(res),
      (err) => error !== undefined ? error(err) : toast.error(HandleErrors(err))
    );
  },

  Delete: async function (id, response, error) {
    await BaseService(
      {
        method: "DELETE",
        url: `delivery/${id}`,
      },
      (res) => response(res),
      (err) => error !== undefined ? error(err) : toast.error(HandleErrors(err))
    );
  },

  GetOne: async function (id, response, error) {
    await BaseService(
      {
        method: "GET",
        url: `delivery/${id}`,
      },
      (res) => response(res),
      (err) => error !== undefined ? error(err) : toast.error(HandleErrors(err))
    );
  },

  Get: async function (userId, take, response, error) {
    await BaseService(
      {
        method: "GET",
        url: `delivery/?userId=${userId}&take=${take}`,
      },
      (res) => response(res),
      (err) => error !== undefined ? error(err) : toast.error(HandleErrors(err))
    );
  },

  Filter: async function (userId, start, end, response, error) {
    await BaseService(
      {
        method: "GET",
        url: `delivery/?userId=${userId}&start=${start}&end=${end}`,
      },
      (res) => response(res),
      (err) => error !== undefined ? error(err) : toast.error(HandleErrors(err))
    );
  },

  ListByStatus: async function (id, response, error) {
    await BaseService(
      {
        method: "GET",
        url: `delivery/${id}/status`,
      },
      (res) => response(res),
      (err) => error !== undefined ? error(err) : toast.error(HandleErrors(err))
    );
  },


  ListDocs: async function (id, response, error) {
    await BaseService(
      {
        method: "GET",
        url: `delivery/${id}/docs`,
      },
      (res) => response(res),
      (err) => error !== undefined ? error(err) : toast.error(HandleErrors(err))
    );
  },

  Start: async function (id, data, response, error) {
    await BaseService(
      {
        method: "POST",
        url: `delivery/${id}/start`,
        data
      },
      (res) => response(res),
      (err) => error !== undefined ? error(err) : toast.error(HandleErrors(err))
    );
  },

  Schedule: async function (data, response, error) {
    await BaseService(
      {
        method: "POST",
        url: `shipsmart/schedule`,
        data
      },
      (res) => response(res),
      (err) => error !== undefined ? error(err) : toast.error(HandleErrors(err))
    );
  },

  GetSchedule: async function (id, response, error) {
    await BaseService(
      {
        method: "GET",
        url: `shipsmart/schedule/${id}`,
      },
      (res) => response(res),
      (err) => error !== undefined ? error(err) : toast.error(HandleErrors(err))
    );
  },

  DeleteSchedule: async function (shippingId, reason, response, error) {
    await BaseService(
      {
        method: "DELETE",
        url: `shipsmart/Schedule/${shippingId}/${reason}`,
      },
      (res) => response(res),
      (err) => error !== undefined ? error(err) : toast.error(HandleErrors(err))
    );
  },

  Search: async function (query, userId, response, error) {
    await BaseService(
      {
        method: "GET",
        url: `delivery/search?userId=${userId}&query=${query}`
      },
      (res) => response(res),
      (err) => error !== undefined ? error(err) : toast.error(HandleErrors(err))
    );
  },
}